import { ActiveMembershipStatuses, MembershipStatus } from '../types';

export const filterPromosForMemberships = (active: boolean, slug: string, state?: MembershipStatus) => {
  if (!active) return false;
  const isMember = state && ActiveMembershipStatuses.includes(state);
  return !(slug.includes('membership') && isMember);
}
